// Échap en pile (dernier ouvert, premier fermé) : une boîte Radix qui SE FERME sur Échap marque l'événement
// natif (document, phase de capture) ; les visionneurs plein écran écoutant `window` ignorent alors ce même appui.
const MARK = "__yalolaEscapeConsumed";

export const consumeEscape = (e) => { const ev = e?.nativeEvent || e; if (ev) ev[MARK] = true; };

export const escapeConsumed = (e) => !!(e?.nativeEvent || e)?.[MARK];
